import { render, staticRenderFns } from "./slots-selector.vue?vue&type=template&id=4104df4c&scoped=true"
import script from "./slots-selector.vue?vue&type=script&lang=js"
export * from "./slots-selector.vue?vue&type=script&lang=js"
import style0 from "./slots-selector.vue?vue&type=style&index=0&id=4104df4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104df4c",
  null
  
)

export default component.exports